import { MenuDropdown } from '@/components/Common';
import { DataTable } from '@/components/Ui';
import { PackageStatus, usePackage } from '@/pages/Coupons/package.hook';
import React from 'react';

const PackageList = () => {
  const {
    packagesList,
    packageConfig,
    packageMenuItems,
    packageColums,
    setSubsPackage,
    packageListLimit,
  } = usePackage();

  const getStatusDisplay = (status: string) => {
    const statusKey = status as PackageStatus;
    const config = packageConfig[statusKey];
    return config ? (
      <span className={config.color}>{config.label}</span>
    ) : (
      <span>{status}</span>
    );
  };

  const lists = packagesList?.map((item) => {
    return {
      ...item,
      status: getStatusDisplay(item.isActive.toString()),
      duration: <span> {item.duration} jrs </span>,
      action: (
        <div onClick={() => setSubsPackage(item)}>
          <MenuDropdown
            menuItems={packageMenuItems}
            dotsStyle="bg-[#FEC20033]"
          />
        </div>
      ),
    };
  });
  return (
    <div className="w-full">
      <DataTable
        columns={packageColums}
        value={lists || []}
        withPaginator={true}
        listlimit={
          packagesList && packagesList?.length < 30 ? 30 : packageListLimit
        }
        countTotal={packagesList?.length}
      />
    </div>
  );
};

export default PackageList;
